import { getCountry } from 'utils/country';
import countries from 'constants/countries';

const defaultSharedSeatsRatio = [
  {
    day: 1,
    ratio: {
      [countries.US]: 2,
      [countries.UK]: 2,
      [countries.FR]: 2,
      [countries.EU]: 2,
      [countries.DE]: 2,
    },
    seats: 1,
  },
  {
    day: 2,
    ratio: {
      [countries.US]: 1.5,
      [countries.UK]: 2,
      [countries.FR]: 1.5,
      [countries.EU]: 1.5,
      [countries.DE]: 1.5,
    },
    seats: 1,
  },
  {
    day: 3,
    ratio: {
      [countries.US]: 1,
      [countries.UK]: 1,
      [countries.FR]: 1,
      [countries.EU]: 1,
      [countries.DE]: 1,
    },
    seats: 1,
  },
  {
    day: 4,
    ratio: {
      [countries.US]: 1,
      [countries.UK]: 1,
      [countries.FR]: 1,
      [countries.EU]: 1,
      [countries.DE]: 1,
    },
    seats: 1,
  },
  {
    day: 5,
    ratio: {
      [countries.US]: 1,
      [countries.UK]: 1,
      [countries.FR]: 1,
      [countries.EU]: 1,
      [countries.DE]: 1,
    },
    seats: 1,
  },
];

const getDefaultSharedSeatsRatio = (country = getCountry()) => {
  return defaultSharedSeatsRatio.map((day) => {
    return {
      day: day.day,
      ratio: day.ratio[country],
      seats: day.seats,
    };
  });
};

export default getDefaultSharedSeatsRatio;
